import React, { useState } from 'react'
import { Checkbox, TextField } from '../../ui'

export function DeliverablesFacet({ deliverables, onToggle, onAdd, onRemove }) {
  const [draft, setDraft] = useState('')

  if (!deliverables) return null

  const items = deliverables.items || []
  const doneCount = items.filter((d) => d.done).length

  function handleAdd(e) {
    e.preventDefault()
    const text = draft.trim()
    if (!text) return
    onAdd?.(text)
    setDraft('')
  }

  return (
    <div style={styles.facet}>
      <span style={styles.count}>{doneCount}/{items.length} done</span>
      <div style={styles.list}>
        {items.map((d) => (
          <div key={d.id} style={styles.item}>
            <Checkbox
              checked={d.done}
              onChange={() => onToggle?.(d.id)}
              aria-label={`Mark "${d.text}" done`}
              style={{ margin: 0, flexShrink: 0 }}
            />
            <span style={{ ...styles.text, ...(d.done ? styles.done : {}) }}>{d.text}</span>
            {onRemove && (
              <button
                type="button"
                style={styles.removeBtn}
                aria-label="Remove deliverable"
                onClick={() => onRemove(d.id)}
              >×</button>
            )}
          </div>
        ))}
      </div>
      {onAdd && (
        <form onSubmit={handleAdd} style={styles.addRow}>
          <div style={{ flex: 1 }}>
            <TextField
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              placeholder="Add deliverable..."
              aria-label="Add deliverable"
            />
          </div>
        </form>
      )}
    </div>
  )
}

const styles = {
  facet: { display: 'flex', flexDirection: 'column', gap: '6px' },
  count: { fontSize: '10px', color: 'var(--text-secondary)' },
  list: { display: 'flex', flexDirection: 'column', gap: '4px' },
  item: { display: 'flex', alignItems: 'center', gap: '6px' },
  checkbox: { margin: 0, flexShrink: 0, cursor: 'pointer' },
  text: { fontSize: '12px', color: 'var(--text-primary)', lineHeight: 1.4 },
  done: { textDecoration: 'line-through', color: 'var(--text-secondary)' },
  removeBtn: {
    marginLeft: 'auto',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '11px',
    color: 'var(--text-secondary)',
    opacity: 0.5,
    padding: '0 2px',
  },
  addRow: { display: 'flex', gap: '6px' },
  addInput: {
    flex: 1,
    fontSize: '12px',
    padding: '4px 8px',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    background: 'var(--bg)',
    color: 'var(--text-primary)',
  },
}
